import { lazy } from "react"
import { RouteObject } from "react-router"

const AboutUs = lazy(() => import("@/pages/aboutUs"))
const Privacy = lazy(() => import("@/pages/privacy"))
const Agreement = lazy(() => import("@/pages/agreement"))
const RealName = lazy(() => import("@/pages/realName"))

const routers: RouteObject[] = [
  {
    path: "/",
    element: <div>这里是首页</div>,
  },
  // 关于我们
  {
    path: "/aboutUs",
    element: <AboutUs />,
  },
  // 隐私协议
  {
    path: "/privacy",
    element: <Privacy />,
  },
  // 使用协议
  {
    path: "/agreement",
    element: <Agreement />,
  },
  // 实名认证
  {
    path: "/realName",
    element: <RealName />,
  },
]

export default routers
